
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { TypographyComponent } from '../typography/typography.component'

@Component({
  selector: 'hyperkit-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  standalone: true,
  imports: [TypographyComponent], // Import CommonModule for directives like ngClass
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent {
  private _value = 0 // Private backing field

  @Input() set value(val: number) {
    this._value = Math.min(100, Math.max(0, val))
  }
  get value(): number {
    return this._value
  }
}
